import Head from "next/head";
import { withTranslation } from "next-i18next";
import SharedAccountsLayout from "@components/core/SharedAccountsLayout";
import Button from "@components/core/Button";
import Link from "@components/core/Link";

function SupportQuestion({ supportQuestion, t }) {
  return (
    <div className="flex-grow-1 d-flex flex-column">
      <Head>
        <title>{`${supportQuestion.title} ${t("help:question_title_suffix")}`}</title>
        <meta name="description" key="description" content={supportQuestion.content?.slice(0,320)} />
      </Head>

      <SharedAccountsLayout title="support" />
      
      <div className="d-flex flex-grow-1 justify-content-center py-6 mt-md-6">
        <div className="container support-question-container">
          <div className="mb-6">
            <h2 className="h3 mb-4 text-center">
              {supportQuestion.title}
            </h2>

            <p className="mb-0 text-center faq-support-content">
              {supportQuestion.content}
            </p>
          </div>

          <div className="d-flex flex-column align-items-center gap-3">
            {supportQuestion.link_path && supportQuestion.link_text && (
              <a href={supportQuestion.link_path} style={{ maxWidth: "100%" }}>
                <Button
                  variant="primary"
                >
                  {supportQuestion.link_text}
                </Button>
              </a>
            )}

            <Link
              href="/help/contact-us"
              passHref
            >
              <Button
                variant="ghost-primary"
              >
                {t("help:contact_support")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation("help")(SupportQuestion);
